import { supertypeClass, property } from '@haventech/amorphic';
import { IsomorphicPersistent } from '@hit/amorphic-types/index';
import { Party } from './Party';
import { POLICY_DOC_ACTION_TYPE } from '../static/PolicyDocActionType';
import { PolicyDoc } from './PolicyDoc';
import { Admin } from '../Admin';

@supertypeClass({ toClient: false, toServer: false })
export class PolicyDocAction extends IsomorphicPersistent {
  @property({
    getType: () => Party,
    comment: `The party that acted on the policy doc`,
  })
  party: Party;

  @property({ rule: ['required'], comment: `What was done to the policy doc` })
  action: POLICY_DOC_ACTION_TYPE;

  /*
    This is an optional field.

    We want to avoid a FK relationship to policy_doc as we sometimes delete policy_doc rows
    but we want to keep these records for them.

    Further, since the id is generated in the database, this will be null for the POLICY_DOC_ACTION_TYPE.CREATED entries.
    That's because the _id on the policyDoc is not yet available/generated.
   */
  @property({
    comment: `The policy doc record that was acted on`,
  })
  policy_doc_id: string;

  @property({
    comment: `Name of the policy doc. This is for convenience as the policy_doc_id may be missing.`,
  })
  policy_doc_name: string;

  @property({
    comment: `Additional context on the action`,
  })
  comment: string;

  @property({
    comment: `ipAddress of party creating, updating or deleting the doc`,
  })
  ipAddress: string;

  constructor() {
    super();
  }

  static new() {
    return new PolicyDocAction().init();
  }

  init() {
    return this;
  }

  static newWithProps(
    policyDoc: PolicyDoc,
    party: Party | Admin,
    action: POLICY_DOC_ACTION_TYPE,
    ipAddress?: string
  ): PolicyDocAction {
    const pda = PolicyDocAction.new();
    pda.policy_doc_id = policyDoc._id;
    pda.policy_doc_name = policyDoc.name;
    pda.ipAddress = ipAddress;
    if (party instanceof Party) {
      pda.party = party;
    } else if (party instanceof Admin) {
      const admin = party as Admin;
      pda.comment = `Acted on by ${admin.getFullName()} [${admin.massMutualId}] acting as ${admin.role}`;
    }

    pda.action = action;

    return pda;
  }
}
